import * as React from 'react';
import { Box, Container, Grid } from '@mui/material';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import TaskTable from './Table/TaskTab';
import TaskGroupsTable from './Table/TaskGroupsTab'
import TaskVariablesTable from './Table/TaskVariablesTab';
import { MuiThemeProvider } from '@material-ui/core/styles';
import { muiThemeDesign } from '../mui-theme-design';
import {logger,checkAuthentication} from '../utils';
import EventsTable from './Table/EventsTab';


interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
}

function TabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ p: 3 }}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

function a11yProps(index: number) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

 export default function EventTabs() {
    const [value, setValue] = React.useState(0);

    const handleChange = (event: React.SyntheticEvent, newValue: number) => {
        setValue(newValue);
    };

    return (
        <MuiThemeProvider theme={muiThemeDesign}>
	        <Box sx={{ width: '100%'  }}>
	            <Box sx={{ borderBottom: 1, borderColor: 'divider'}}>
                    <Tabs value={value} onChange={handleChange} aria-label="EventsTab" sx={{ paddingTop: { xs: 8, sm: 8, md: 8, lg: 8, xl: 2 }, '& .MuiTabs-indicator': { display: 'none' } }}
               //         className={classes.tabPanel}
                        >
	                    <Tab label="" {...a11yProps(0)} />                  
	                </Tabs>
	            </Box>
	            
				<TabPanel value={value} index={0}>
	                <EventsTable />
	            </TabPanel>
	            
            </Box> 
        </MuiThemeProvider>
    );
}